/** Public header nav (in-app routes). */
export const PUBLIC_NAV_LINKS = [
  { label: "Products", to: "/products" },
  { label: "Services", to: "/services" },
  { label: "Plans", to: "/pricing" },
  { label: "Contact Us", to: "/contact" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Refund Policy", to: "/refund-policy" },
  { label: "Delete Account", to: "/delete-account" },
];

/** Public footer links moved off the navbar. */
export const PUBLIC_FOOTER_LINKS = [
  { label: "FAQs", to: "/faqs" },
  { label: "About Us", to: "/about" },
];
